import { render, staticRenderFns } from "./Base-Date-Input.vue?vue&type=template&id=0c6fea16&scoped=true&"
import script from "./Base-Date-Input.vue?vue&type=script&lang=js&"
export * from "./Base-Date-Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6fea16",
  null
  
)

export default component.exports